import "./index.less";
import icon_back from "@/assets/icon_back.png";
import { goBackV2 } from "@/utils/common";
import icon_share from "@/assets/icon_share.png";
import { getBrowserEnv } from "@/utils/tools";
import { useEffect, useRef } from "react";

// 头部导航栏
const NavBar = (props) => {
  const { isXPApp } = getBrowserEnv();
  const nav = useRef<HTMLDivElement>(null);
  const paddingTop = 0;
  // if(nav.current){
  //   // 苹果安全区 跟 less  文件 padding-top: env(safe-area-inset-top) 配置的padding 属性绑定
  //   let str = window?.getComputedStyle(nav.current).getPropertyValue("padding-top")
  //   str = str.replace('px','')
  //   str = str.replace('rem','')
  //   paddingTop = Number(str)
  // }
  useEffect(() => {
    props.navLoad?.({
      navHeight: (nav.current?.clientHeight || 0) + paddingTop,
    });
  }, []);

  const goBack = () => {
    if(props.onBack){
      props.onBack();
    }
    goBackV2();
  };

  return (
    <div ref={nav}>
      {isXPApp && (
        <div style={{ backgroundColor: "#ffffff", height: "88rem" }}></div>
      )}
      <div className="navbar" ref={nav}>
        <img className="back" src={icon_back} onClick={goBack} />
        <div className="title">{props.title}</div>
        {props.showShare ? (
          <img
            className="icon"
            style={{ top: "88rem" }}
            src={icon_share}
            onClick={props.onClickRight}
          />
        ) : (
          <div className="icon"></div>
        )}
      </div>
    </div>
  );
};

export default NavBar;
